module.exports = __webpack_public_path__ + "static/media/dog.52b54f5d.png";